import AppletSubgroupType from "../../../models/applet/applet-subgroup-type.entity";
import UserSession from "../../../models/session/user-session.entity";
import http from "../../../services/http.service";
import storageService from "../../../services/storage.service";
import { rejectApiError } from "../../../services/api-error.service";

class AppletSubgroupService {
  public getAppleSubgroupList(appletProfileId: string) {
    const sessionObj: UserSession = new UserSession(storageService.getObject('session'));
    return sessionObj.appletSubgroupType
      .find((appletType) => appletType.profiles
        .some((profile) => profile.id === appletProfileId && profile.appletSubgroups.length > 0))
      || new AppletSubgroupType();
  }

  public refreshAppletSubgroup = async (companyId: string, appletProfileId: string) => http
    .get(`/applet-subgroup?company_id=${companyId}&applet_profile_id=${appletProfileId}`)
    .catch(rejectApiError);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AppletSubgroupService();
